import { Map } from 'immutable';

import Api from '../api';

import BudgetAllocation from './model';
import { addAction, addMultipleAction, updateAction, removeAction } from './actions';
import { VOLUNTEER_REWARD_BUDGET_ALLOCATION } from './constants';

export default class BudgetAllocationsApi {
  static fetchAll() {
    return Api.get('api/budgetAllocations').map((budgetAllocations: BudgetAllocation[]) =>
      addMultipleAction(
        Map(
          budgetAllocations.map((budgetAllocation: BudgetAllocation) => [
            budgetAllocation.id,
            new BudgetAllocation(budgetAllocation),
          ])
        )
      )
    );
  }

  static fetch(id: string) {
    return Api.get(`api/budgetAllocations/${id}`).map((budgetAllocation: BudgetAllocation) =>
      addAction(new BudgetAllocation(budgetAllocation))
    );
  }

  static create(data, type) {
    return Api.post(`api/budgetAllocations?type=${type}`, data).map((budgetAllocation) =>
      addAction(new BudgetAllocation(budgetAllocation))
    );
  }

  static update(id, data, type) {
    if (type === VOLUNTEER_REWARD_BUDGET_ALLOCATION) {
      alert(`Update not supported for volunteer grants rule at the moment`);
      return null;
    }
    return Api.patch(`api/budgetAllocations/${id}`, data).map((budgetAllocation) =>
      updateAction(new BudgetAllocation(budgetAllocation))
    );
  }

  static delete(id, type) {
    if (type === VOLUNTEER_REWARD_BUDGET_ALLOCATION) {
      alert(`Deletion not supported for volunteer grants rules at the moment`);
      return null;
    }
    return Api.delete(`api/budgetAllocations/${id}`).map(() => removeAction(id));
  }
}
